import React from 'react';
import { Stack, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { JoinCard } from './JoinCard';

const JoinsTab = ({
  joins,
  labelColor,
  accentColor,
  onFieldChange,
  onAddJoin,
  onRemoveJoin,
  onAddCondition,
  onRemoveCondition,
  onConditionChange
}) => (
  <Stack spacing={3}>
    {(joins || []).map((join, index) => (
      <JoinCard
        key={(join.join_id || join.target_table || 'join') + '-' + index}
        join={join}
        index={index}
        labelColor={labelColor}
        accentColor={accentColor}
        onFieldChange={onFieldChange}
        onConditionChange={onConditionChange}
        onAddCondition={onAddCondition}
        onRemoveCondition={onRemoveCondition}
        onRemoveJoin={onRemoveJoin}
      />
    ))}
    <Button
      variant="outlined"
      startIcon={<AddIcon />}
      onClick={onAddJoin}
      sx={{ alignSelf: 'flex-start', borderColor: accentColor, color: accentColor }}
    >
      Agregar join
    </Button>
  </Stack>
);

export default JoinsTab;
